import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { apiInstance } from '../../Apis/Axios';
import { URL } from '../../Apis/Constants';
import cryptoJs from 'crypto-js';
import securekey from '../../config';
import { EMPLOYEE_SERVICE, ROLE_SERVICE, SYSTEM_CONFIG_SERVICE } from '../EndPoints';
import {AUTHENTICATION_SERVICE} from "../EndPoints";

const config = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
    },
};

export const tokenApi = createAsyncThunk('authenticationSlice/tokenApi', async (params) => {
    try {
        return await axios.post(`${URL}token`, params, config);
    } catch (error) {
        if (!error.response) {
            toast.error( "Connection failed")
            return { data: null, status: 0 };
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const loginMiddleware = createAsyncThunk('authenticationSlice/loginMiddleware', async (authValues, thunkAPI) => {
    try {
        const response = await apiInstance.post('authentication-service/log-in-web-app', authValues.values, {overlay:false});
        if (response.status === 200) {
            const userData = cryptoJs.AES.encrypt(JSON.stringify(response), securekey);
            sessionStorage.setItem('userdata', userData);
            return { ...response.data };
        } else {
            return thunkAPI.rejectWithValue(response.data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data);
    }
});

export const loginMiddlewareV2 = createAsyncThunk('authenticationSlice/loginMiddleware', async (authValues, thunkAPI) => {
    try {
        const response = await apiInstance.post('authentication-service/v2/log-in-web-app', authValues.values, {overlay:false});
        if (response.status === 200) {
            const userData = cryptoJs.AES.encrypt(JSON.stringify(response), securekey);
            sessionStorage.setItem('userdata', userData);
            return { ...response.data };
        } else {
            return thunkAPI.rejectWithValue(response.data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data);
    }
});

export const RoleCheck = createAsyncThunk('authenticationSlice/roleCheck', async (params) => {
    const { roleId } = params;
    const result = await apiInstance
        .get(`${ROLE_SERVICE.roleCheck}${roleId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// this api consist of user info Data which is call at app Start.
export const GetUserByIdAtEntry = createAsyncThunk('authenticationSlice/getUserByIdAtEntry', async (params) => {
    const result = await apiInstance
        .get(EMPLOYEE_SERVICE.getUserByIdAtEntry)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetConfigByName = createAsyncThunk(
    'authenticationSlice/getConfigByName',
    async (params, { dispatch, getState }) => {
        try {
            return await axios.get(`${URL+ SYSTEM_CONFIG_SERVICE.getConfigByName + params}`, config);
        } catch (error) {
            if (!error.response) {
                toast.error( "Connection failed")
                return { data: null, status: 0 };
            }
            return { data: error.response.data, status: error.response.status };
        }
    },
);

export const SendEmailToResetPassword = createAsyncThunk(
    'authenticationSlice/sendEmailToResetPassword',
    async (username, { dispatch, getState }) => {
        const result = await axios
            .get(URL+AUTHENTICATION_SERVICE.sendEmailToResetPassword(username))
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const VerifyOtp = createAsyncThunk(
    'authenticationSlice/verifyOtp',
    async (payload) => {
        const result = await axios
            .post(URL + AUTHENTICATION_SERVICE.verifyOtp, payload)
            .then(response => response)
            .catch(error => error.response);

        const { data, status } = result;

        return { data, status };
    },
);

export const NewPassword = createAsyncThunk(
    'authenticationSlice/newPassword',
    async ({ resetToken, newPassword }, { dispatch, getState }) => {
        const result = await axios
            .put(URL + AUTHENTICATION_SERVICE.newPassword, { resetToken, newPassword })
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
